export enum UserRulesTemplateApiUrls {
  CreateUserRulesTemplate = '/api/UserRulesTemplates/CreateUserRulesTemplate',
  EditUserRulesTemplate = '/api/UserRulesTemplates/EditUserRulesTemplate',
  GetUserRulesTemplateById = '/api/UserRulesTemplates/GetUserRulesTemplateById',
  GetUserRulesTemplatesByUserId = '/api/UserRulesTemplates/GetUserRulesTemplatesByUserId',
  GetUserRulesTemplatesByUserIdIncludingDefault= '/api/UserRulesTemplates/GetUserRulesTemplatesByUserIdIncludingDefault',
  DeleteUserRulesTemplatesById = '/api/UserRulesTemplates/DeleteUserRulesTemplateById',
}
